module.exports = __webpack_public_path__ + "static/media/icono-salir.cd63a260.png";